import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import auth from "@services/auth/auth";
import { Paths } from "@/paths";

export default function NoAccessPage() {
    const navigate = useNavigate();

    const logOut = () => {
        auth.logOut();
        navigate(`${import.meta.env.BASE_URL}${Paths.LOGIN}`);
    };

    return (
        <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center px-3">
            <h4 className="mb-3">No features are accessible.</h4>
            <p className="text-muted mb-4">Contact your admin.</p>
            <Button variant="outline-secondary" onClick={logOut}>
                Log out
            </Button>
        </div>
    );
}
